// @flow

import React, { Component } from 'react'

import './FilterButton.css'

type Props = {
  currentFilter: string,
  filterBy: Function
}

type State = {
  dropDown: boolean
}

/**
  * Button for datetime filter
  * @class
  * @extends Component
*/
class DateTimeFilter extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      dropDown: false
    }
  }

  /** render function */
  render () {
    return (
      <div className='dateFilter'>
        <div className='default'>
          <button onClick={() => this.props.filterBy('Day')} className={this.props.currentFilter === 'Day' ? 'selected' : ''}> Day </button>
          <button onClick={() => this.props.filterBy('Week')} className={this.props.currentFilter === 'Week' ? 'selected' : ''}> Week </button>
          <button onClick={() => this.props.filterBy('Month')} className={this.props.currentFilter === 'Month' ? 'selected' : ''}> Month </button>
          <button onClick={() => this.props.filterBy('Custom')} className={this.props.currentFilter === 'Custom' ? 'selected' : ''}> Custom </button>
        </div>
        <div className='smallScreen'>
          <button onClick={() => this.setState({ dropDown: !this.state.dropDown })}>...</button>
          {(this.state.dropDown)
            ? <div className='dropDown'>
            <button onClick={() => { this.setState({ dropDown: false }); this.props.filterBy('Day') }} className={this.props.currentFilter === 'Day' ? 'selected' : ''}> Day </button>
            <button onClick={() => { this.setState({ dropDown: false }); this.props.filterBy('Week') }} className={this.props.currentFilter === 'Week' ? 'selected' : ''}> Week </button>
            <button onClick={() => { this.setState({ dropDown: false }); this.props.filterBy('Month') }} className={this.props.currentFilter === 'Month' ? 'selected' : ''}> Month </button>
            <button onClick={() => { this.setState({ dropDown: false }); this.props.filterBy('Custom') }} className={this.props.currentFilter === 'Custom' ? 'selected' : ''}> Custom </button>
          </div>
            : '' }
        </div>
      </div>
    )
  }
}

export default DateTimeFilter
